<template>
    <ModalComponent
        :name="name"
        title="Descargar arqueo de caja"
        v-on:close="() => close()"
    >
        <div class="card-body">                    
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="del">DEL</label>
                        <input type="date" id="del" placeholder="Del" v-model="fecha_inicio"/>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="al">AL</label>
                        <input type="date" id="al" placeholder="Al" v-model="fecha_fin"/>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="teatros">Teatro</label>
                        <multiselect
                            v-model="teatro"
                            placeholder="Teatro"
                            label="nombre"
                            track-by="id"
                            :options="teatros"
                            :multiple="false"
                        />
                    </div>                                          
                    <div class="form-group">
                        <label for="taquilleros">Taquillero</label>
                        <multiselect
                            v-model="taquillero"
                            placeholder="Taquillero"
                            label="nombre"
                            track-by="id"
                            :options="taquilleros"
                            :multiple="false"
                        />
                    </div>
                    <div class="form-group">
                        <label for="companias">Compañias</label>
                        <multiselect
                            v-model="compania"
                            placeholder="Compañia"
                            label="nombre"
                            track-by="id"
                            :options="companias"
                            :multiple="false"
                        >
                            <template #noResult>
                                <span>No se encontraron compañias con ese nombre.</span>
                            </template>
                        </multiselect>
                    </div>
                    <div class="mt-4">
                        <Button @click="getInformeArqueoCaja()">DESCARGAR</Button>
                    </div>
                </div>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['name', 'teatro_id', 'taquillero_id', 'teatro_company_id', 'del', 'al', 'pasado', 'actual', 'teatros', 'taquilleros', 'companias'],
        data() {
            return {
                loading: false,
                fecha_inicio: null,
                fecha_fin: null,
                pasados: false,
                actuales: false,
                taquillero: null,
                teatro: null,
                compania: null
            }
        },
        methods: {
            getInformeArqueoCaja() {
                var enlace = this.config.API_BASE + '/eventos/resumen-ventas/arqueo-caja?api_key=' + localStorage.getItem('token') + '&search_teatro_id=' + (this.teatro_id ?? this.teatro.id) + '&tid=' + this.configuracion.hash_teatro;

                if (this.taquillero) {
                    enlace +=  '&taquillero_id=' + this.taquillero.id ;
                }
                if (this.fecha_inicio) {
                    enlace +=  '&fecha_inicio=' + this.fecha_inicio;
                }
                if (this.fecha_fin) {
                    enlace +=  '&fecha_fin=' + this.fecha_fin;
                }
                if (this.pasado) {
                    enlace +=  '&pasado=' + this.pasado;
                }
                if (this.actual) {
                    enlace +=  '&actual=' + this.actual;
                }
                if (this.compania) {
                    enlace += '&teatro_company_id=' + this.compania.id;
                }

                window.open(enlace);
                this.close();
            },
            close() {
                this.$emit('close', this.name);
            }
        },
        created() {
            this.fecha_inicio = this.del;
            this.fecha_fin = this.al;
            this.pasados = this.pasado;
            this.actuales = this.actual;

            if (this.taquillero_id && this.taquilleros) {
                this.taquillero = this.taquilleros.find(taquillero => taquillero.id === this.taquillero_id);
            }

            if (this.teatro_id && this.teatros) {
                this.teatro = this.teatros.find(teatro => teatro.id === this.teatro_id);
            }

            if (this.teatro_company_id && this.companias?.length > 0) {
                this.compania = this.companias.find(compania => compania.id === this.teatro_company_id)
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
